<mat-toolbar class="navbar-container">
  <div class="logo-container" routerLink="/">
    <img class="logo" src="assets/images/logos/logo-inline-inverse.png" alt="Logo" />
  </div>

  <span class="spacer"></span>

  <div class="right-side">
    <div class="language" [matMenuTriggerFor]="languageMenu">
      <div class="icon" [style.background-image]="LanguageEnum.icon($language())"></div>
      <div class="name">{{ LanguageEnum.name($language()) | translate }}</div>
    </div>

    <mat-menu #languageMenu="matMenu" class="language-menu">
      @for (language of LanguageEnum.languages; track language) {
        <button mat-menu-item (click)="handleLanguageChange(language)" [class.active]="language === $language()">
          <div class="language-option">
            <div class="icon" [style.background-image]="LanguageEnum.icon(language)"></div>
            <span>{{ LanguageEnum.name(language) | translate }}</span>
          </div>
        </button>
      }
    </mat-menu>

    @if (authenticated()) {
      <div class="profile-logo" [matMenuTriggerFor]="profileMenu">
        {{ $user()?.firstName?.[0] }}
      </div>

      <mat-menu #profileMenu="matMenu" class="profile-menu">
        <div class="profile">
          <div class="logo">{{ $user()?.firstName?.[0] }}</div>
          <div class="profile-infos">
            <span>{{ $user()?.firstName }} {{ $user()?.lastName }}</span>
            <span>{{ $user()?.email }}</span>
            <span>Org Admin</span>
            <span>v{{ version }}</span>
          </div>
        </div>

        <div mat-menu-item [matMenuTriggerFor]="settingsMenu">
          <mat-icon>settings</mat-icon>
          <span>{{ 'navbar.settings' | translate }}</span>
        </div>

        <div mat-menu-item [matMenuTriggerFor]="toolsMenu">
          <mat-icon>handyman</mat-icon>
          <span>{{ 'navbar.tools' | translate }}</span>
        </div>

        <div mat-menu-item data-cy="logout-button" (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>{{ 'navbar.logout' | translate }}</span>
        </div>
      </mat-menu>

      <mat-menu #settingsMenu="matMenu" class="settings-menu">
        <div mat-menu-item [routerLink]="[Paths.SETTINGS_PATH, Paths.PROFILE_PATH]">
          <mat-icon>account_circle</mat-icon>
          <span>{{ 'navbar.profile' | translate }}</span>
        </div>
      </mat-menu>
      <mat-menu #toolsMenu="matMenu" class="tools-menu">
        <div mat-menu-item [routerLink]="[Paths.INITIAL_SCAN_PATH]">
          <mat-icon>wifi_find</mat-icon>
          <span>{{ 'navbar.initialScan' | translate }}</span>
        </div>
        <div mat-menu-item (click)="openGenerateExecutiveReportDialog()">
          <mat-icon>assessment</mat-icon>
          <span>{{ 'navbar.generateExecutiveReport' | translate }}</span>
        </div>
        <div mat-menu-item (click)="openGenerateDetailedReportDialog()">
          <mat-icon>description</mat-icon>
          <span>{{ 'navbar.generateDetailReport' | translate }}</span>
        </div>
        <div mat-menu-item (click)="openGenerateFullReportDialog()">
          <mat-icon>description</mat-icon>
          <span>{{ 'navbar.generateFullReport' | translate }}</span>
        </div>
      </mat-menu>
    }
  </div>
</mat-toolbar>
